/** @jsxImportSource @emotion/react */
import { Grid, Typography } from '@mui/material';
import React from 'react';
import ExpansionGrid from '../../Components/ExpansionGrid';

function AddressDetailsReview(props) {
    const { reviewData } = props

    const apiKeysUsedForDisplayingLabel = {
        "corrAddress1": "Correspondence Address line 1",
        "corrAddress2": "Correspondence Address line 2",
        "corrAddress3": "Correspondence Address line 3",
        "corrLandMark": "Correspondence Address Landmark",
        "corrAddressPincode": "Correspondence Address Pincode",
        "corrAddressCity": "Correspondence Address City",
        "corrAddressState": "Correspondence Address State",
        "corrAddressCountry": "Correspondence Address Country",
        "permAddress1": "Permanent Address line 1",
        "permAddress2": "Permanent Address line 2",
        "permAddress3": "Permanent Address line 3",
        "permLandMark": "Permanent Address Landmark",
        "permAddressPinCode": "Permanent Address Pincode",
        "permAddressCity": "Permanent Address City",
        "permAddressState": "Permanent Address State",
        "permAddressCountry": "Permanent Address Country"
    }

    const getAccordianData = () => {
        return <Grid container spacing={3} css={{padding:"10px"}}>
            { reviewData && reviewData?.kycStagingPersonalDetails && Object.keys(apiKeysUsedForDisplayingLabel).map(apiKey=>
                <Grid container item xs={6} md={3} lg={2} alignItems={"center"} css={{border:"1px dashed lightgrey"}}>
                    <Grid item xs={12}>
                        <Typography variant="body2" css={{color:"#0098B0"}}>{apiKeysUsedForDisplayingLabel[apiKey]}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" /* color="#333333" fontWeight={"bold"} */ css={{wordBreak:"break-word"}}>{(reviewData && reviewData.kycStagingAddressDetails[apiKey]) || "--"}</Typography>
                    </Grid>
                </Grid>
            )}
        </Grid>
    }

    return (
        <ExpansionGrid title={"Address Details"} accordianData={getAccordianData()} />
    );
}

export default AddressDetailsReview;